export class EmployeeLeaveDetailModel {
    openingBalance: number;
    closingBalance: number;
    leaves: number;
    year: number;
    month: number;
    leaveTypeAndDate: EmployeeLeaveTypeAndDate[];

}
export class EmployeeLeaveTypeAndDate {
    // constructor() {
    //     this.name = "";
    //     this.fromDate = "";
    // }
    name: string;
    fromDate: Date;
}